import { render, staticRenderFns } from "./AddBeaconToClusterConfirmation.vue?vue&type=template&id=0d9778ae&"
import script from "./AddBeaconToClusterConfirmation.vue?vue&type=script&lang=js&"
export * from "./AddBeaconToClusterConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports